module.exports = __webpack_public_path__ + "67760aef05971628af86c12a8b4d8ef5.png";